module.exports = __webpack_public_path__ + "static/media/Artboard4.c2aa1a6b.png";